import { create } from "zustand";


export const useStore = create((set, get) => ({
    showDropdown : false,
    

    setShowDropdown: (state) => {
        set({ showDropdown: state });
    },

    
}));
